(() => {
  if (window.__piurCheckoutPropertiesInstalled) return;
  window.__piurCheckoutPropertiesInstalled = true;

  const PUBLIC_TO_PRIVATE_KEYS = {
    Farbe: '_Farbe',
    Color: '_Color',
    'Zus\u00e4tzliche Informationen': '_Zus\u00e4tzliche Informationen',
    'Zusatzliche Informationen': '_Zusatzliche Informationen',
    'Additional information': '_Additional information',
    'Additional Information': '_Additional Information',
  };

  const PRIVATE_TO_PUBLIC_KEYS = {
    _Farbe: 'Farbe',
    _Color: 'Color',
    '_Zus\u00e4tzliche Informationen': 'Zus\u00e4tzliche Informationen',
    '_Zusatzliche Informationen': 'Zusatzliche Informationen',
    '_Additional information': 'Additional information',
    '_Additional Information': 'Additional Information',
  };

  const COLOR_TRANSLATIONS = {
    hellblau: 'Light Blue',
    hellgrau: 'Light Grey',
    altrosa: 'Dusty Pink',
    mintgruen: 'Mint',
    mintgrun: 'Mint',
    'mintgr\u00fcn': 'Mint',
    navyblau: 'Navy Blue',
    anthrazit: 'Anthracite',
    weiss: 'White',
    'wei\u00df': 'White',
    schwarz: 'Black',
    grau: 'Gray',
    blau: 'Blue',
    gruen: 'Green',
    'gr\u00fcn': 'Green',
    braun: 'Brown',
    rosa: 'Rose',
  };

  const PHRASE_TRANSLATIONS = [
    [/\bCapri\s*\/\s*Navyblau\b/gi, 'Capri/Navy Blue'],
    [/\bIceland\s*\/\s*Hellblau\b/gi, 'Iceland/Light Blue'],
    [/\bManhattan\s*\/\s*Hellgrau\b/gi, 'Manhattan/Light Grey'],
    [/\bFuji\s*\/\s*Anthrazit\b/gi, 'Fuji/Anthracite'],
    [/\bLisboa\s*\/\s*Altrosa\b/gi, 'Lisboa/Dusty Pink'],
    [/\bMale\s*\/\s*Mintgr(?:u|ü)n\b/gi, 'Male/Mint'],
    [/\bSantorin\s*\/\s*Wei(?:ss|ß)\b/gi, 'Santorin/White'],
  ];

  const cartRootSelector = [
    '#occ3-drawer',
    '.spurit-occ3__slide-drawer',
    '[data-occ3="cart"]',
    '[data-occ2="cart-wrapper"]',
    '[data-cartly-drawer]',
    '[data-cartly-container]',
    '[class*="cartly"]',
    '[id*="cartly"]',
    'cart-drawer',
    '#CartDrawer',
    'form[action*="/cart"]',
    '.cart',
    '.cart__contents',
  ].join(', ');

  let isPreparingCheckout = false;
  let isRestoringDisplay = false;
  let checkoutPreparationPromise = null;

  function routesRoot() {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return typeof root === 'string' && root ? root : '/';
  }

  function cartUrl(path) {
    return `${routesRoot()}cart/${path}`.replace(/\/{2,}/g, '/');
  }

  function checkoutUrl() {
    return `${routesRoot()}checkout`.replace(/\/{2,}/g, '/');
  }

  function normalizeText(value) {
    return String(value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function currentLocale() {
    const extractLocaleFromPath = (value) => {
      const normalizedPath = normalizeText(value).toLowerCase();
      if (!normalizedPath) return '';
      const match = normalizedPath.match(/\/(de|en)(?:[-_][a-z]{2})?(?:\/|$)/);
      return match ? match[1] : '';
    };

    const routesRootLocale = extractLocaleFromPath(window.Shopify && window.Shopify.routes && window.Shopify.routes.root);
    if (routesRootLocale) return routesRootLocale;

    const pathLocale = extractLocaleFromPath(window.location && window.location.pathname);
    if (pathLocale) return pathLocale;

    const docLang = normalizeText(document.documentElement.lang).toLowerCase();
    if (docLang.startsWith('de')) return 'de';
    if (docLang.startsWith('en')) return 'en';

    const shopifyLocale = normalizeText(
      (window.Shopify && (window.Shopify.locale || window.Shopify.language)) || ''
    ).toLowerCase();
    if (shopifyLocale.startsWith('de')) return 'de';
    if (shopifyLocale.startsWith('en')) return 'en';

    return 'en';
  }

  function translateColorPart(part, locale) {
    const raw = normalizeText(part);
    if (!raw || locale !== 'en') return raw;

    const translated = COLOR_TRANSLATIONS[raw.toLowerCase()];
    return translated || raw;
  }

  function localizeBundleValue(value, locale) {
    let output = normalizeText(value);
    if (!output) return '';

    output = output
      .replace(/\bZipper\s*\(hidden\)/gi, 'zipper (concealed)')
      .replace(/\bZipper\s*\(concealed\)/gi, 'zipper (concealed)')
      .replace(/\bRei(?:\u00df|ss)verschluss\b/gi, locale === 'en' ? 'zipper (concealed)' : 'Rei\u00dfverschluss')
      .replace(/\s*\(hidden\)\s*/gi, ' ')
      .replace(/\bhidden\b/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    if (locale !== 'en') return output;

    PHRASE_TRANSLATIONS.forEach(([pattern, replacement]) => {
      output = output.replace(pattern, replacement);
    });

    output = output
      .replace(/^Kopfkissenbezug\s*-\s*/i, 'Pillowcase Cover - ')
      .replace(/^Kissenbezug\s*-\s*/i, 'Pillowcase Cover - ')
      .replace(/^Bettdeckenbezug\s*-\s*/i, 'Duvet Cover - ')
      .replace(/^Deckenbezug\s*-\s*/i, 'Duvet Cover - ');

    const slashParts = output.split('/').map((part) => normalizeText(part));
    if (slashParts.length > 1) {
      output = slashParts
        .map((part) => {
          if (/\d{2,4}\s*x\s*\d{2,4}/i.test(part) || /zipper/i.test(part)) return part;

          const prefixMatch = part.match(/^(.*-\s*)?(.+)$/);
          const prefix = prefixMatch && prefixMatch[1] ? prefixMatch[1] : '';
          const color = prefixMatch && prefixMatch[2] ? prefixMatch[2] : part;
          return `${prefix}${translateColorPart(color, locale)}`;
        })
        .join(' / ');
    }

    return output;
  }

  async function fetchCart() {
    const response = await fetch(cartUrl('js'), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!response.ok) throw new Error(`Cart fetch failed: ${response.status}`);
    return response.json();
  }

  async function changeLineProperties(line, properties) {
    const response = await fetch(cartUrl('change.js'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({ line, properties }),
    });
    if (!response.ok) throw new Error(`Cart change failed: ${response.status}`);
    return response.json();
  }

  function preparePropertiesForCheckout(properties, locale) {
    if (!properties || typeof properties !== 'object') return null;

    const nextProperties = { ...properties };
    let changed = false;

    Object.entries(PUBLIC_TO_PRIVATE_KEYS).forEach(([publicKey, privateKey]) => {
      if (!Object.prototype.hasOwnProperty.call(nextProperties, publicKey)) return;

      const value = localizeBundleValue(nextProperties[publicKey], locale);
      if (value) nextProperties[privateKey] = value;
      delete nextProperties[publicKey];
      changed = true;
    });

    Object.keys(nextProperties).forEach((key) => {
      if (!/^_(?:Kissenbezug|Deckenbezug|Pillowcase|Duvet cover|Pillowcase cover|Duvet Cover|Farbe|Color)$/i.test(key)) return;

      const localizedValue = localizeBundleValue(nextProperties[key], locale);
      if (localizedValue && localizedValue !== nextProperties[key]) {
        nextProperties[key] = localizedValue;
        changed = true;
      }
    });

    Object.keys(nextProperties).forEach((key) => {
      if (!/^_?Product\s+\d+$/i.test(key)) return;

      delete nextProperties[key];
      changed = true;
    });

    Object.keys(nextProperties).forEach((key) => {
      if (!/^_Zus(?:\u00e4|a)tzliche Informationen$/i.test(key) && !/^_Additional Information$/i.test(key)) return;

      const value = normalizeText(nextProperties[key]);
      if (!value) {
        delete nextProperties[key];
        changed = true;
      }
    });

    return changed ? nextProperties : null;
  }

  function restorePropertiesForDisplay(properties) {
    if (!properties || typeof properties !== 'object') return null;

    const nextProperties = { ...properties };
    let changed = false;

    Object.entries(PRIVATE_TO_PUBLIC_KEYS).forEach(([privateKey, publicKey]) => {
      if (!Object.prototype.hasOwnProperty.call(nextProperties, privateKey)) return;
      if (Object.prototype.hasOwnProperty.call(nextProperties, publicKey)) return;

      const value = normalizeText(nextProperties[privateKey]);
      if (!value) return;

      nextProperties[publicKey] = value;
      changed = true;
    });

    return changed ? nextProperties : null;
  }

  async function updateCartProperties(transformProperties) {
    const cart = await fetchCart();
    if (!cart || !Array.isArray(cart.items)) return false;

    let updated = false;
    for (let index = cart.items.length - 1; index >= 0; index -= 1) {
      const line = cart.items[index];
      const nextProperties = transformProperties(line && line.properties);
      if (!nextProperties) continue;

      await changeLineProperties(index + 1, nextProperties);
      updated = true;
    }

    if (updated) {
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('cartly:updated'));
      document.dispatchEvent(new CustomEvent('occ3:updated'));
    }

    return updated;
  }

  async function prepareCartForCheckout() {
    if (checkoutPreparationPromise) return checkoutPreparationPromise;
    isPreparingCheckout = true;
    checkoutPreparationPromise = (async () => {
      try {
        const locale = currentLocale();
        await updateCartProperties((properties) => preparePropertiesForCheckout(properties, locale));
        window.sessionStorage && window.sessionStorage.setItem('piurCheckoutPropertiesPrepared', '1');
      } finally {
        isPreparingCheckout = false;
        checkoutPreparationPromise = null;
      }
    })();

    return checkoutPreparationPromise;
  }

  async function restoreCartForDisplay() {
    if (isRestoringDisplay || /\/checkout(?:\/|$)/i.test(window.location.pathname)) return;
    isRestoringDisplay = true;
    try {
      await updateCartProperties(restorePropertiesForDisplay);
    } catch (error) {
      // Display restoration is best-effort; checkout preparation still runs on click.
    } finally {
      isRestoringDisplay = false;
    }
  }

  function getTriggerText(element) {
    if (!(element instanceof HTMLElement)) return '';
    return normalizeText(
      element.getAttribute('aria-label') ||
        element.getAttribute('title') ||
        element.value ||
        element.textContent ||
        ''
    );
  }

  function isCheckoutText(text) {
    return /\bcheckout\b|zur\s+kasse|\bkasse\b/i.test(text || '');
  }

  function isInteractiveCheckoutElement(element) {
    if (!(element instanceof HTMLElement)) return false;
    return (
      element.matches('a, button, input, [role="button"], [role="link"], [tabindex]') ||
      element.hasAttribute('onclick')
    );
  }

  function isCheckoutTrigger(element) {
    if (!(element instanceof HTMLElement)) return false;
    if (element.closest('.shopify-payment-button, [data-shopify="payment-button"]')) return false;

    const href = element instanceof HTMLAnchorElement ? element.getAttribute('href') || '' : '';
    if (/\/checkout(?:[/?#]|$)/i.test(href)) return true;

    const name = normalizeText(element.getAttribute('name')).toLowerCase();
    if (name === 'checkout') return true;

    const formAction = normalizeText(element.getAttribute('formaction'));
    if (/\/checkout(?:[/?#]|$)/i.test(formAction)) return true;

    const form = element.closest('form');
    const formActionAttr = normalizeText(form && form.getAttribute('action'));
    const inCartContext = Boolean(element.closest(cartRootSelector));
    if (!inCartContext || !isInteractiveCheckoutElement(element)) return false;

    const marker = normalizeText(`${element.id || ''} ${element.className || ''}`);
    if (inCartContext && isCheckoutText(marker)) return true;

    if (inCartContext && formActionAttr && /\/cart(?:[/?#]|$)/i.test(formActionAttr) && isCheckoutText(getTriggerText(element))) {
      return true;
    }

    return inCartContext && isCheckoutText(getTriggerText(element));
  }

  function findCheckoutTrigger(eventTarget) {
    if (!(eventTarget instanceof Element)) return null;

    const directTarget = eventTarget.closest(
      'a, button, input, [role="button"], [role="link"], [tabindex], [onclick]'
    );
    if (directTarget instanceof HTMLElement && isCheckoutTrigger(directTarget)) return directTarget;

    return null;
  }

  function submitAfterPreparation(form, submitter) {
    if (form instanceof HTMLFormElement) {
      form.dataset.piurCheckoutPrepared = 'true';
      if (typeof form.requestSubmit === 'function' && submitter instanceof HTMLElement) {
        form.requestSubmit(submitter);
        return;
      }
      form.submit();
      return;
    }

    window.location.assign(checkoutUrl());
  }

  document.addEventListener(
    'click',
    async (event) => {
      const target = findCheckoutTrigger(event.target);
      if (!target || !isCheckoutTrigger(target)) return;

      const form = target.closest('form');
      const rawHref = target instanceof HTMLAnchorElement ? target.getAttribute('href') || '' : '';
      const checkoutHref = /\/checkout(?:[/?#]|$)/i.test(rawHref) ? target.href : '';

      event.preventDefault();
      event.stopPropagation();

      try {
        await prepareCartForCheckout();
      } catch (error) {
        // Continue to checkout even if the cart API request fails.
      }

      if (checkoutHref) {
        window.location.assign(checkoutHref);
        return;
      }

      submitAfterPreparation(form, target);
    },
    true
  );

  ['pointerdown', 'mousedown', 'touchstart'].forEach((eventName) => {
    document.addEventListener(
      eventName,
      (event) => {
        const target = findCheckoutTrigger(event.target);
        if (!target || !isCheckoutTrigger(target)) return;
        prepareCartForCheckout().catch(() => {});
      },
      true
    );
  });

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.dataset.piurCheckoutPrepared === 'true') {
        delete form.dataset.piurCheckoutPrepared;
        return;
      }

      const submitter = event.submitter instanceof HTMLElement ? event.submitter : null;
      const formAction = normalizeText(form.getAttribute('action'));
      const isCartCheckoutSubmit =
        /\/cart(?:[/?#]|$)/i.test(formAction) &&
        (normalizeText(submitter && submitter.getAttribute('name')).toLowerCase() === 'checkout' ||
          isCheckoutText(getTriggerText(submitter || form)));

      if (!isCartCheckoutSubmit) return;

      event.preventDefault();
      try {
        await prepareCartForCheckout();
      } catch (error) {
        // Continue to checkout even if the cart API request fails.
      }
      submitAfterPreparation(form, submitter);
    },
    true
  );

  // Private checkout properties stay private in the cart. Cartly display is restored
  // separately from /cart.js by cartly-line-item-format.js.
})();
